
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSleetShowersNight as ObiSleetShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sleet-showers-night.js';
 
 
 

 
 export const ObiSleetShowersNight = createComponent({
   react: React,
   tagName: 'obi-sleet-showers-night',
   elementClass: ObiSleetShowersNightElement,
   events: {
     
   }
  });
 
 